<div>
	<p-dialog appendTo="body" [(visible)]="visible" (onHide)="hide()" [modal]="true" [resizable]="false"
			  [style]="{'width': '1120px', 'height': '450px'}">

		<p-header>
			<span>Config History</span>
		</p-header>

		<config-history [visible]="visible"
						[monitorType]="monitorType" 
						[deviceGuid]="deviceGuid"
						[monitorPolicyGuid]="monitorPolicyGuid"></config-history>

		<p-footer>
			<button type="button" pButton icon="fa fa-close" (click)="hide()" label="Close"></button>
		</p-footer>

	</p-dialog>

</div>